import { render } from "./DefaultSelection.vue?vue&type=template&id=1d5dd4ca&scoped=true"
import script from "./DefaultSelection.vue?vue&type=script&lang=js"
export * from "./DefaultSelection.vue?vue&type=script&lang=js"

import "./DefaultSelection.vue?vue&type=style&index=0&id=1d5dd4ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5dd4ca"]])

export default __exports__